export const Quiz = {
  '题目题干要求': '題目題幹要求',
  '正确答案': '參考答案',
  '答案公布时间': '答案公佈時間',
  '多模态知识卡': '多模態知識卡',
  '答题设置': '答題設定',
  '分值设置': '分值設定',
  '满分值': '滿分值',
  '直接回答': '直接回答',
  '提示回答': '提示回答',
  '公布后参与': '公佈後參與',
  '分': '分',
  '题目': '題目',
  '点击知识卡可学习相关知识点': '點擊知識卡可學習相關知識點',
  '请选择答题方式': '請選擇答題方式',
  '选择后不可更改请谨慎选择': '選擇後不可更改，請謹慎選擇',
  '由自己独立完成作答': '由自己獨立完成作答',
  'AI将提供引导式指导帮助作答': 'AI將提供引導式指導協助作答',
  '最高可得': '最高可得 ',
  '满分': '滿分',
  '满分的': '滿分的',
  '答案将于': '答案將於 ',
  '公布': ' 公佈',
  '公布答案后参与最高可得': '公佈答案後參與最高可得 ',
  '你选择了直接回答模式': '你選擇了【直接回答】模式，',
  '你选择了提示回答模式': '你選擇了【提示回答】模式，',
  '我的回答': '我的回答',
  '请输入你的回答': '請輸入你的回答...',
  '上传附件': '上傳附件',
  '确认提交': '確認提交',
  'AI学习助手': 'AI學習助手',
  '正在加载AI助手': '正在載入AI助手...',
  '待评分': '待評分',
  '参考答案': '參考答案',
  '相关知识卡': '相關知識卡',
  '点击查看': '點擊查看',
  '操作失败': '操作失敗',
  '提交后不可修改确认提交': '提交後不可修改，確認提交？',
  '提交失败': '提交失敗',
  '答题统计': '答題統計',
  '已答题': '已答題',
  '未答题': '未答題',
  '已评分': '已評分',
  '平均分': '平均分',
  '最高分': '最高分',
  '最低分': '最低分',
  '答题方式分布': '答題方式分佈',
  '人': '人',
  '答题型话题标签': '答題型話題',
  '参考资料': '參考資料',
  '参考资料说明': '為學生提供輔助學習資料，支援多模態知識卡和檔案附件',
  '暂无参考资料': '暫無參考資料',
  '同学作答': '同學作答',
  '暂无其他同学提交': '暫無其他同學提交',
  '上传失败': '上傳失敗',
  '学生作答详情': '學生作答詳情',
  '刷新': '重新整理',
  '修改': '修改',
  '修改得分': '修改得分',
  '评分': '評分',
  '评分成功': '評分成功',
  '评分失败': '評分失敗',
  '打回': '打回',
  '打回成功': '打回成功',
  '打回失败': '打回失敗',
  '确认打回该学生作答': '確認打回該學生作答？',
  '请输入得分': '請輸入得分',
  '取消': '取消',
  '确定': '確定',
  'AI引导智能体': 'AI引導智能體',
  '确认转换': '確認轉換',
  '答题模式说明': '答題型話題包含3種答題模式：',
  '请输入题目题干要求': '請輸入題目題幹要求',
  '请输入正确答案': '請輸入參考答案',
  '答案已公布参与最高可得': '答案已公佈，現在參與最高可得 ',
  '公布后参与答题': '公佈後參與答題',
  'AI助手暂不可用请直接作答': 'AI助手暫時不可用，請直接作答',
  '已选择': '已選擇',
  '你选择了公布后参与模式': '你選擇了【公佈後參與】模式，',
  '暂无参考答案': '老師未提供參考答案',
  '老师未提供参考答案提示': '答案公佈時間已到，但老師尚未設定參考答案內容',
  '确认选择答题方式': '確認選擇答題方式',
  '选择此方式后不可更改': '選擇此方式後不可更改，確認選擇',
  '知识卡': '知識卡',
  '文件': '檔案',
  '暂无题干内容': '暫無題幹內容',
  '答案将于时间公布': '答案將於該時間公佈',
  '加载中': '載入中...',
  '提交成功': '提交成功',
  '选择模式成功': '已成功選擇答題方式',
  '暂无作答': '暫無作答',
  '姓名': '姓名',
  '学号': '學號',
  '答题方式': '答題方式',
  '得分': '得分',
  '提交时间': '提交時間',
  '展开查看': '展開查看',
  '暂无附件': '暫無附件',
  '普通话题': '普通話題',
  '答题型话题': '答題型話題',
  '话题类型': '話題類型',
  '转为答题型话题': '轉為答題型話題',
  '转为普通话题': '轉為普通話題',
  '转为普通话题提示': '轉換後將刪除答題配置，確認轉換為普通話題？',
  '转换成功': '轉換成功',
  '转换提示': '轉換後，該話題將增加答題功能，學生需進行作答。',
  '原话题内容': '原話題內容',
  '一键带入题干要求': '一鍵帶入題幹',
  '带入题干覆盖确认': '當前已有題幹內容，是否覆蓋？',
  '已带入题干要求': '已帶入題幹要求',
  '暂无话题内容': '暫無話題內容',
  '题干附件': '題幹附件',
  '参考资料文件': '參考資料（檔案）',
  '参考答案附件': '參考答案附件',
  '答案公布时间不设置': '不設定（答題後即可查看）',
  '请选择AI引导智能体': '請選擇AI引導智能體（必填）',
  '选择智能体': '選擇智能體',
  '暂无可用智能体': '暫無可用AI引導智能體',
  '添加参考资料': '添加參考資料',
  '教学资料': '教學資料',
  '选择知识卡片': '選擇知識卡片',
  '课程未绑定知识库': '當前課程未綁定多模態知識庫',
  'AI引导智能体辅助说明': 'AI引導答題需要先選擇一個可用智能體；若列表為空，請先前往添加或申請。',
  '搜索智能体': '搜尋智能體',
  '前往添加智能体': '前往添加或申請',
  '无匹配智能体': '無符合結果',
  topicDetailHasBody: '已填正文',
  topicDetailHasFiles: '含附件',

  '师生讨论': '師生討論',
  '老师': '老師',
  '学生': '學生',
  '回复': '回覆',
  '回复至': '回覆',
  '请输入回复内容': '請輸入回覆內容',
  '输入回复内容': '輸入回覆內容...',
  '发表回复': '發表回覆',
  '回复成功': '回覆成功',
  '回复失败': '回覆失敗',
  '删除': '刪除',
  '删除成功': '刪除成功',
  '删除失败': '刪除失敗',
  '确认删除该回复': '確認刪除該回覆？',
  '暂无讨论': '暫無討論',
  '添加附件': '添加附件',
  '讨论': '討論',
  '提示': '提示',
  '收起': '收起',
}
